import {ButtonProps} from '@chakra-ui/react';

// Styles partagés de la FilterBar

// Style checkbox bleu partagé entre tous les filtres FilterBar (popovers desktop,
// drawer mobile, FromageFilterContent...).
export const CHECKBOX_BLUE_SX = {
  '& .chakra-checkbox__control': {
    borderColor: 'gray.light',
    _checked: {bg: 'blue.main', borderColor: 'blue.main'},
  },
} as const;

// Props partagées pour les boutons déclencheurs des filtres (Labels, Fromage, Température...).
export const FILTER_BUTTON_PROPS: Partial<ButtonProps> = {
  color: 'blue.text',
  bg: 'gray.75',
  borderRadius: '8px',
  fontSize: 'sm',
  fontWeight: '400',
  height: '38px',
};
